export default __webpack_public_path__ + "static/media/productValues1.a8a93d76.svg";